import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/box-select.vue
var o = {
	name: "DtIconBoxSelect",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--box-select"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Box Select",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1.44 1.44A1.5 1.5 0 0 1 2.5 1a.5.5 0 0 1 0 1 .5.5 0 0 0-.5.5.5.5 0 0 1-1 0c0-.398.158-.78.44-1.06ZM9 1.5a.5.5 0 0 1 .5-.5A1.5 1.5 0 0 1 11 2.5a.5.5 0 0 1-1 0 .5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5ZM10.5 9a.5.5 0 0 1 .5.5A1.5 1.5 0 0 1 9.5 11a.5.5 0 0 1 0-1 .5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5Zm-9 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 0 1A1.5 1.5 0 0 1 1 9.5a.5.5 0 0 1 .5-.5ZM4 1.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 0 1h-.5a.5.5 0 0 1-.5-.5Zm0 9a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 0 1h-.5a.5.5 0 0 1-.5-.5Zm2.5-9A.5.5 0 0 1 7 1h.5a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5Zm0 9A.5.5 0 0 1 7 10h.5a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5ZM1.5 4a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 .5-.5Zm9 0a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 .5-.5Zm-9 2.5A.5.5 0 0 1 2 7v.5a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5Zm9 0a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=box-select.js.map